import { preloadVideoSources } from '@/utils/preloadVideoSources';

export const CONGRATS_VIDEO_SOURCES = [
  { src: '/videos/auth/congratulation-registeration/congrats-registration-ios.mov', type: 'video/quicktime' },
  { src: '/videos/auth/congratulation-registeration/congrats-registration.webm', type: 'video/webm' },
];

export const preloadCongratsVideo = () => preloadVideoSources(CONGRATS_VIDEO_SOURCES);
